import React, { Fragment } from "react";
import { compose, lifecycle, withState, withProps, withHandlers } from "recompose";
import styled, { keyframes } from "styled-components";
import ReactCountryFlag from "react-country-flag";
import getUserLocation from "../../libs/getUserLocation";
import withUserCountry from "../../core/withUserCountry";
import watermarkIllustration from "../../../images/watermarkIllustration.png";
import updateTopNineOrder from "../../libs/updateTopNineOrder";
import StripeCheckoutHandler from "../common/Checkout/StripeCheckoutHandler";
import Modal from "../common/Modal";
import { Button, PrimaryButton } from "../common/Button";
import SupportUs from "./SupportUs";
import RemoveWatermark from "./RemoveWatermark";
import { FakeStoreButton } from "../GetTopNine/DisableLogin";

const isIphone = typeof navigator !== "undefined" && /iPhone|iPad|iPod/i.test(navigator.userAgent);
const APP_STORE_URL = "https://itunes.apple.com/us/app/top-nine-for-instagram-2017/id1188477208?mt=8";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.bestnine&hl=en";

const BlockingGrid = ({ open, onClose, country, ...props }) => (
  <Fragment>
    <LinkOverlay href={isIphone ? APP_STORE_URL : PLAY_STORE_URL} />
    <Container
      href={isIphone ? APP_STORE_URL : PLAY_STORE_URL}
      onClick={() => {
        if (window.gtag) {
          window.gtag("event", "onclick_blocking_modal");
        }
      }}
    >
      <Headline> Download our app!</Headline>
      <Illustration src={watermarkIllustration} resizeMode="contain" />
      {country && country.code ? (
        <Text>
          Whoa! The web version of Top Nine is currently being used by millions of users worldwide and in{" "}
          {country.name} <ReactCountryFlag code={country.code.toLowerCase()} />.
        </Text>
      ) : (
        <Text>Whoa! The web version of Top Nine is currently being used by millions of users worldwide</Text>
      )}
      <Text style={{ marginTop: "8px" }}>
        Please download our mobile app to get your Top Nine. The app also has many new Instagram Story templates!
      </Text>
      <Text style={{ marginTop: "8px", textAlign: "center" }}>From all of us here working on Top Nine:</Text>
      <Thanks>🙌 THANK YOU! 🙌</Thanks>
      <StoreButtonsContainer>
        <FakeStoreButton isIphone={true} />
        <FakeStoreButton isIphone={false} />
      </StoreButtonsContainer>
    </Container>
  </Fragment>
);

const Container = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0px 20px 10px;
`;

const LinkOverlay = styled.a`
  display: block;
  position: fixed;
  left: -100%;
  top: -100%;
  width: 400vw;
  height: 400vh;
`;

const ButtonContainer = styled.div`
  width: 95%;
`;

const Headline = styled.h3`
  text-align: center;
  margin: 18px auto;
  font-size: 24px;
  @media (max-height: 550px) {
    font-size: 20px;
    margin-bottom: 5px;
    margin-top: 10px;
  }
`;

const Illustration = styled.img`
  height: 120px;
  width: auto;
  margin: 10px auto;
  display: block;
  object-fit: contain;
  @media (max-height: 550px) {
    height: 100px;
  }
`;

const Text = styled.p`
  color: black;
  margin-bottom: 8px !important;
  font-size: 14px !important;
  text-align: center;
  @media (max-height: 550px) {
    font-size: 12px !important;
  }
`;

const Thanks = styled.p`
  width: 100%;
  text-align: center;
  margin: 12px;
  font-weight: bolder;
  color: black;
  font-size: 14px;
  @media (max-height: 500px) {
    margin: 0px;
  }
`;

const StoreButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
`;

const BlockingGridModal = props => (
  <CustomModal {...props}>
    <BlockingGrid {...props} />
  </CustomModal>
);

const CustomModal = styled(Modal)`
  background-color: #ffffff;
  width: 95%;
  padding: 10px;
  @media (min-width: 640px) {
    max-width: 450px;
  }
`;

export default withUserCountry(BlockingGridModal);
